import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppRouteParam } from 'src/app/app.route';

export const businessUnitInterceptor: HttpInterceptorFn = (req, next) => {
  const activatedRoute = inject(ActivatedRoute);
  const businessUnit = activatedRoute.root.firstChild?.snapshot.paramMap.get(AppRouteParam.BusinessUnit);

  if (!businessUnit) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      'X-BusinessUnitCode': businessUnit as string,
    },
  });

  return next(authReq);
};
